import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { Box, Container, Heading, Text, VStack, Flex, Image, Table, Tbody, Tr, Td, Icon } from '@chakra-ui/react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
interface LandingPage888Props {
  checkoutUrl?: string;
}
export function LandingPage888({
  checkoutUrl = 'https://pay.hotmart.com/G105090565O?checkoutMode=10'
}: LandingPage888Props) {
  // Meta Pixel Initialization
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const initPixel = () => {
      !function (f: any, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.head;
        if (s) {
          s.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq?.('init', '1461988308668328');
      (window as any).fbq?.('track', 'PageView');
    };
    initPixel();
  }, []);
  const handleCheckoutClick = () => {
    ;
    (window as any).fbq?.('track', 'InitiateCheckout');
  };
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 100);
  };
  return <Box bg="#0f172a" minH="100vh" color="whiteAlpha.900" fontFamily="'Inter', system-ui, sans-serif" data-id="element-530">
      <Container maxW="3xl" py={{
      base: 10,
      md: 16
    }} pb={{
      base: 32,
      md: 20
    }} data-id="element-531">
        <VStack spacing={12} align="stretch" data-id="element-532">
          {/* 1. HERO SECTION */}
          <Box textAlign="center" data-id="element-533">
            <Heading as="h1" fontSize={{
            base: '3xl',
            md: '5xl',
            lg: '6xl'
          }} fontWeight="black" lineHeight="1.1" mb={6} fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-534">
              Descubrimiento reciente revela por qué el 97% de los rituales de
              abundancia fallan… y cómo activar el dinero en menos de 7 días
              usando el{' '}
              <Text as="span" color="#ffd700" data-id="element-535">
                Código 888
              </Text>
            </Heading>
            <Text fontSize="2xl" color="whiteAlpha.800" mb={8} fontWeight="medium" data-id="element-536">
              Acceso inmediato por solo $28.88 USD
            </Text>

            <CTAButton text="QUIERO ACTIVAR MI ABUNDANCIA AHORA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-537" />

            <Flex justify="center" gap={{
            base: 4,
            md: 8
          }} mt={6} color="whiteAlpha.600" fontSize={{
            base: 'xs',
            md: 'sm'
          }} flexWrap="wrap" textTransform="uppercase" letterSpacing="widest" data-id="element-538">
              <Flex align="center" gap={2} data-id="element-539">
                <Text color="#ffd700" data-id="element-540">✔</Text> Acceso inmediato
              </Flex>
              <Flex align="center" gap={2} data-id="element-541">
                <Text color="#ffd700" data-id="element-542">✔</Text> Pago seguro
              </Flex>
              <Flex align="center" gap={2} data-id="element-543">
                <Text color="#ffd700" data-id="element-544">✔</Text> Garantía 7 días
              </Flex>
            </Flex>
          </Box>

          {/* 2. VIDEO SECTION */}
          <Box textAlign="center" data-id="element-545">
            <Box w="100%" position="relative" borderRadius="2xl" overflow="hidden" border="1px solid rgba(255, 215, 0, 0.2)" boxShadow="0 20px 50px -12px rgba(255, 184, 0, 0.25)" mb={8} sx={{
            aspectRatio: '16 / 9'
          }} data-id="element-546">
              <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/pEdNTtgPC4Cc8vhyagpk9i/invideo-ai-720%20Este%20888%20desbloquea%20tu%20dinero%20en%20d%C3%ADas%202026-04-02%20(1)%20(1).mp4" controls={isVideoPlaying} playsInline preload="metadata" style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} data-id="element-547" />
              {!isVideoPlaying && <Flex position="absolute" top={0} left={0} right={0} bottom={0} align="center" justify="center" bg="rgba(0, 0, 0, 0.4)" cursor="pointer" onClick={handlePlayVideo} zIndex={2} transition="background 0.3s" _hover={{
              bg: 'rgba(0, 0, 0, 0.25)'
            }} data-id="element-548">
                  <Box as="svg" viewBox="0 0 68 48" w={{
                base: '68px',
                md: '90px'
              }} h={{
                base: '48px',
                md: '63px'
              }} sx={{
                '& .ytp-bg': {
                  fill: '#212121',
                  fillOpacity: 0.8,
                  transition: 'fill 0.1s, fill-opacity 0.1s'
                },
                '&:hover .ytp-bg': {
                  fill: '#f00',
                  fillOpacity: 1
                }
              }} data-id="element-549">
                    <path className="ytp-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" data-id="element-550" />
                    <path fill="#fff" d="M 45,24 27,14 27,34" data-id="element-551" />
                  </Box>
                </Flex>}
            </Box>
            <CTAButton text="VER AHORA Y ACTIVAR PROTOCOLO" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-552" />
          </Box>

          {/* 3. PROBLEMA */}
          <Box textAlign="center" bg="rgba(255, 255, 255, 0.02)" p={{
          base: 8,
          md: 12
        }} borderRadius="3xl" border="1px solid rgba(255, 255, 255, 0.05)" data-id="element-553">
            <VStack spacing={6} align="center" mb={10} data-id="element-554">
              <Flex align="center" gap={4} data-id="element-555">
                <Text color="red.400" fontSize="2xl" fontWeight="bold" data-id="element-556">
                  ✕
                </Text>
                <Text fontSize="xl" color="whiteAlpha.900" data-id="element-557">
                  Haces rituales pero el dinero no llega
                </Text>
              </Flex>
              <Flex align="center" gap={4} data-id="element-558">
                <Text color="red.400" fontSize="2xl" fontWeight="bold" data-id="element-559">
                  ✕
                </Text>
                <Text fontSize="xl" color="whiteAlpha.900" data-id="element-560">
                  Repites afirmaciones pero todo sigue igual
                </Text>
              </Flex>
              <Flex align="center" gap={4} data-id="element-561">
                <Text color="red.400" fontSize="2xl" fontWeight="bold" data-id="element-562">
                  ✕
                </Text>
                <Text fontSize="xl" color="whiteAlpha.900" data-id="element-563">
                  Sientes que el universo te ignora
                </Text>
              </Flex>
            </VStack>

            <Heading as="h2" size="2xl" mb={8} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-564">
              No es tu culpa
            </Heading>

            <CTAButton text="QUIERO CAMBIAR ESTO" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-565" />
          </Box>

          {/* 4. REVELACIÓN */}
          <Box textAlign="center" px={{
          base: 4,
          md: 8
        }} data-id="element-566">
            <Heading as="h2" size="xl" mb={6} color="white" fontFamily="'Playfair Display', Georgia, serif" lineHeight="1.4" data-id="element-567">
              Tu capacidad de atraer dinero no está dañada, lo que está
              bloqueado es tu{' '}
              <Text as="span" color="#ffd700" data-id="element-568">
                canal de recepción
              </Text>
            </Heading>
            <Text fontSize="xl" color="whiteAlpha.800" lineHeight="1.6" data-id="element-569">
              Has pasado años intentando atraer abundancia desde la
              desesperación y la necesidad. Esto ha creado un cortocircuito en
              tu mente, asociando el dinero con el estrés y bloqueando su
              llegada sin que te des cuenta.
            </Text>
          </Box>

          {/* 5. DESCUBRIMIENTO & 6. ERROR */}
          <Box textAlign="center" bg="rgba(255, 215, 0, 0.03)" p={{
          base: 8,
          md: 12
        }} borderRadius="3xl" border="1px solid rgba(255, 215, 0, 0.1)" data-id="element-570">
            <Text fontSize="lg" mb={4} color="#ffd700" textTransform="uppercase" letterSpacing="widest" fontWeight="bold" data-id="element-571">
              El Descubrimiento
            </Text>
            <Heading as="h3" size="xl" mb={6} color="white" fontFamily="'Playfair Display', Georgia, serif" data-id="element-572">
              El Mecanismo del Código 888
            </Heading>
            <Text fontSize="xl" mb={8} color="whiteAlpha.900" data-id="element-573">
              Investigadores descubrieron que las culturas antiguas utilizaban
              una frecuencia específica para sintonizar su cerebro con la
              abundancia.
            </Text>

            <Box bg="rgba(245, 101, 101, 0.1)" p={6} borderRadius="xl" border="1px solid rgba(245, 101, 101, 0.2)" data-id="element-574">
              <Text fontSize="xl" color="red.300" fontWeight="bold" mb={2} data-id="element-575">
                El Gran Error:
              </Text>
              <Text fontSize="lg" color="whiteAlpha.900" data-id="element-576">
                Hacer rituales desde el miedo o la escasez hace que tu mente
                bloquee automáticamente cualquier resultado positivo.
              </Text>
            </Box>
          </Box>

          {/* 7. SOLUCIÓN */}
          <Box textAlign="center" data-id="element-577">
            <Heading as="h2" size="2xl" mb={6} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-578">
              La Solución Simple
            </Heading>
            <Text fontSize="xl" mb={8} color="whiteAlpha.900" data-id="element-579">
              Al escuchar la frecuencia exacta de 888Hz, tu cerebro entra en el
              estado correcto de receptividad, eliminando la resistencia y
              abriendo tu canal a la abundancia.
            </Text>
            <CTAButton text="ACTIVAR PROTOCOLO 888 AHORA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-580" />
          </Box>

          {/* 8. RESULTADOS */}
          <Box textAlign="center" px={{
          base: 4,
          md: 8
        }} data-id="element-581">
            <Heading as="h3" size="xl" mb={8} fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-582">
              Lo que experimentarás:
            </Heading>
            <VStack spacing={6} align="center" data-id="element-583">
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={8} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" w="100%" maxW="500px" data-id="element-584">
                <Icon as={CheckCircleIcon} color="#ffd700" boxSize={6} data-id="element-585" />
                <Text fontSize="lg" color="whiteAlpha.900" fontWeight="medium" data-id="element-586">
                  Dinero en menos de 7 días
                </Text>
              </Flex>
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={8} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" w="100%" maxW="500px" data-id="element-587">
                <Icon as={CheckCircleIcon} color="#ffd700" boxSize={6} data-id="element-588" />
                <Text fontSize="lg" color="whiteAlpha.900" fontWeight="medium" data-id="element-589">
                  Oportunidades inesperadas
                </Text>
              </Flex>
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={8} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" w="100%" maxW="500px" data-id="element-590">
                <Icon as={CheckCircleIcon} color="#ffd700" boxSize={6} data-id="element-591" />
                <Text fontSize="lg" color="whiteAlpha.900" fontWeight="medium" data-id="element-592">
                  Menos ansiedad financiera
                </Text>
              </Flex>
            </VStack>
          </Box>

          {/* 9. TESTIMONIOS */}
          <Box data-id="element-593">
            <Heading as="h3" size="xl" mb={8} textAlign="center" fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-594">
              Historias de éxito reales
            </Heading>
            <VStack spacing={6} data-id="element-595">
              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} data-id="element-596">
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-597">
                  <Image src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="Testimonio 1" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-598" />
                  <Box data-id="element-599">
                    <Flex mb={2} gap={1} justify={{
                    base: 'center',
                    md: 'flex-start'
                  }} data-id="element-600">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="sm" data-id="element-601">
                          ★
                        </Text>)}
                    </Flex>
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} fontStyle="italic" data-id="element-602">
                      "A los 4 días de escuchar el audio 888, me llamaron para
                      un trabajo que me pagó $1,200 dólares. No lo podía creer."
                    </Text>
                    <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-603">
                      María Elena R. • Guadalajara, México
                    </Text>
                  </Box>
                </Flex>
              </Box>

              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} data-id="element-604">
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-605">
                  <Image src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="Testimonio 2" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-606" />
                  <Box data-id="element-607">
                    <Flex mb={2} gap={1} justify={{
                    base: 'center',
                    md: 'flex-start'
                  }} data-id="element-608">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="sm" data-id="element-609">
                          ★
                        </Text>)}
                    </Flex>
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} fontStyle="italic" data-id="element-610">
                      "En la primera semana nos devolvieron un dinero que
                      dábamos por perdido hace 2 años. Seguimos escuchándolo
                      cada noche."
                    </Text>
                    <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-611">
                      Carlos Andrés M. • Monterrey, México
                    </Text>
                  </Box>
                </Flex>
              </Box>

              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} data-id="element-612">
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-613">
                  <Image src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="Testimonio 3" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-614" />
                  <Box data-id="element-615">
                    <Flex mb={2} gap={1} justify={{
                    base: 'center',
                    md: 'flex-start'
                  }} data-id="element-616">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="sm" data-id="element-617">
                          ★
                        </Text>)}
                    </Flex>
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} fontStyle="italic" data-id="element-618">
                      "Al día 5 me ofrecieron un aumento en el trabajo y una
                      clienta me pagó por adelantado. La energía cambió por
                      completo."
                    </Text>
                    <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-619">
                      Lucía Fernanda P. • Ciudad de México, México
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </VStack>
          </Box>

          {/* 10. PRODUCTO & 11. CÓMO FUNCIONA */}
          <Box textAlign="center" bg="rgba(255, 255, 255, 0.02)" p={{
          base: 8,
          md: 12
        }} borderRadius="3xl" border="1px solid rgba(255, 215, 0, 0.15)" data-id="element-620">
            <Heading as="h2" size="2xl" mb={4} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-621">
              Protocolo Frecuencia 888
            </Heading>
            <Text fontSize="xl" mb={12} color="whiteAlpha.800" data-id="element-622">
              El sistema definitivo diseñado para sintonizar tu cerebro con la
              frecuencia de la abundancia desde el primer día.
            </Text>

            <Heading as="h4" size="md" mb={8} color="white" textTransform="uppercase" letterSpacing="widest" data-id="element-623">
              CÓMO FUNCIONA EN 3 PASOS
            </Heading>
            <Flex direction={{
            base: 'column',
            md: 'row'
          }} justify="center" gap={8} align="center" data-id="element-624">
              <VStack data-id="element-625">
                <Box bg="rgba(255,215,0,0.1)" w="60px" h="60px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="2px solid #ffd700" color="#ffd700" fontWeight="bold" fontSize="2xl" data-id="element-626">
                  1
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="white" data-id="element-627">
                  Activas el protocolo
                </Text>
              </VStack>
              <Box w={{
              base: '2px',
              md: '40px'
            }} h={{
              base: '30px',
              md: '2px'
            }} bg="rgba(255,215,0,0.3)" data-id="element-628" />
              <VStack data-id="element-629">
                <Box bg="rgba(255,215,0,0.1)" w="60px" h="60px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="2px solid #ffd700" color="#ffd700" fontWeight="bold" fontSize="2xl" data-id="element-630">
                  2
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="white" data-id="element-631">
                  Escuchas el audio
                </Text>
              </VStack>
              <Box w={{
              base: '2px',
              md: '40px'
            }} h={{
              base: '30px',
              md: '2px'
            }} bg="rgba(255,215,0,0.3)" data-id="element-632" />
              <VStack data-id="element-633">
                <Box bg="rgba(255,215,0,0.1)" w="60px" h="60px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="2px solid #ffd700" color="#ffd700" fontWeight="bold" fontSize="2xl" data-id="element-634">
                  3
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="white" data-id="element-635">
                  Recibes abundancia
                </Text>
              </VStack>
            </Flex>
          </Box>

          {/* 12. LO QUE RECIBES */}
          <Box data-id="element-636">
            <Heading as="h3" size="xl" mb={8} textAlign="center" fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-637">
              Todo lo que incluye tu acceso hoy:
            </Heading>
            <Box bg="rgba(15, 23, 42, 0.8)" border="1px solid rgba(255, 215, 0, 0.4)" borderRadius="xl" overflow="hidden" mb={10} maxW="500px" mx="auto" data-id="element-638">
              <Table variant="simple" size="md" data-id="element-639">
                <Tbody data-id="element-640">
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-641">
                    <Td fontSize="md" py={4} color="white" data-id="element-642">
                      <Text as="span" color="#ffd700" mr={3} fontWeight="bold" data-id="element-643">
                        ✓
                      </Text>{' '}
                      Manual Maestro del Ritual 888
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-644">
                    <Td fontSize="md" py={4} color="white" data-id="element-645">
                      <Text as="span" color="#ffd700" mr={3} fontWeight="bold" data-id="element-646">
                        ✓
                      </Text>{' '}
                      Audio de Activación 888Hz
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-647">
                    <Td fontSize="md" py={4} color="white" data-id="element-648">
                      <Text as="span" color="#ffd700" mr={3} fontWeight="bold" data-id="element-649">
                        ✓
                      </Text>{' '}
                      Diario de Sincronías
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-650">
                    <Td fontSize="md" py={4} color="white" data-id="element-651">
                      <Text as="span" color="#ffd700" mr={3} fontWeight="bold" data-id="element-652">
                        ✓
                      </Text>{' '}
                      Diccionario Palabras Prohibidas
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-653">
                    <Td fontSize="md" py={4} color="white" data-id="element-654">
                      <Text as="span" color="#ffd700" mr={3} fontWeight="bold" data-id="element-655">
                        ✓
                      </Text>{' '}
                      Certificado CICPA
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>

            <Text fontSize="2xl" fontWeight="bold" color="#ffd700" textAlign="center" mb={6} fontFamily="'Playfair Display', Georgia, serif" data-id="element-656">
              + 2 BONOS DE ACCIÓN RÁPIDA:
            </Text>

            <Flex direction={{
            base: 'column',
            md: 'row'
          }} gap={6} justify="center" data-id="element-657">
              <Box flex="1" bg="rgba(255, 215, 0, 0.05)" border="1px solid rgba(255, 215, 0, 0.2)" borderRadius="xl" p={6} textAlign="center" data-id="element-658">
                <Image src="https://cdn.magicpatterns.com/uploads/2YNmMyJkQYZxLWPSNutJ2i/1_regalo.png" alt="Audio Reset 888" loading="lazy" w="120px" mx="auto" mb={4} borderRadius="md" data-id="element-659" />
                <Heading as="h4" size="md" color="white" mb={2} data-id="element-660">
                  Audio Reset 888
                </Heading>
                <Text fontSize="sm" color="whiteAlpha.800" data-id="element-661">
                  Borra bloqueos subconscientes sobre el dinero antes de dormir.
                </Text>
              </Box>
              <Box flex="1" bg="rgba(255, 215, 0, 0.05)" border="1px solid rgba(255, 215, 0, 0.2)" borderRadius="xl" p={6} textAlign="center" data-id="element-662">
                <Image src="https://cdn.magicpatterns.com/uploads/634LcXA2r2HZYSjbDxMSd4/regalo_2.png" alt="Audio Candado 888" loading="lazy" w="120px" mx="auto" mb={4} borderRadius="md" data-id="element-663" />
                <Heading as="h4" size="md" color="white" mb={2} data-id="element-664">
                  Audio Candado 888
                </Heading>
                <Text fontSize="sm" color="whiteAlpha.800" data-id="element-665">
                  Crea un escudo energético para que el dinero se quede y se
                  multiplique.
                </Text>
              </Box>
            </Flex>
          </Box>

          {/* 13. PRECIO */}
          <Box textAlign="center" pt={8} data-id="element-666">
            <Text fontSize="2xl" textDecoration="line-through" color="red.400" mb={2} fontWeight="bold" data-id="element-667">
              Valor normal: $247 USD
            </Text>
            <Heading as="h2" fontSize={{
            base: '6xl',
            md: '8xl'
          }} fontWeight="black" color="#ffd700" mb={8} letterSpacing="tighter" data-id="element-668">
              $28.88 USD
            </Heading>
            <CTAButton text="QUIERO ACCESO POR $28.88" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-669" />
          </Box>

          {/* 14. GARANTÍA & 15. URGENCIA */}
          <VStack spacing={6} data-id="element-670">
            <Flex align="center" justify="center" gap={4} bg="rgba(255, 255, 255, 0.05)" border="1px solid rgba(255, 255, 255, 0.1)" borderRadius="xl" p={6} w="100%" maxW="500px" data-id="element-671">
              <Icon as={ShieldCheckIcon} boxSize={10} color="#ffd700" data-id="element-672" />
              <Text fontSize="lg" fontWeight="bold" color="white" data-id="element-673">
                7 días o te devolvemos el dinero. Sin preguntas.
              </Text>
            </Flex>

            <Box bg="rgba(245, 101, 101, 0.1)" border="1px solid rgba(245, 101, 101, 0.3)" borderRadius="xl" p={4} w="100%" maxW="500px" textAlign="center" data-id="element-674">
              <Text color="red.300" fontWeight="bold" fontSize="lg" data-id="element-675">
                ⚠️ Oferta limitada, puede terminar en cualquier momento.
              </Text>
            </Box>
          </VStack>

          {/* 16. CIERRE & 17. CTA FINAL */}
          <Box textAlign="center" pt={8} pb={12} data-id="element-676">
            <Heading as="h2" size="xl" mb={6} color="white" fontFamily="'Playfair Display', Georgia, serif" data-id="element-677">
              No es tu culpa, tu sistema está bloqueado.
            </Heading>
            <Text fontSize="xl" color="whiteAlpha.800" mb={10} data-id="element-678">
              Es hora de abrir las puertas a la abundancia que mereces.
            </Text>

            <CTAButton text="ACTIVAR MI ABUNDANCIA HOY" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-679" />

            <Flex justify="center" gap={6} mt={6} color="whiteAlpha.500" fontSize="sm" flexWrap="wrap" data-id="element-680">
              <Flex align="center" gap={2} data-id="element-681">
                <Icon as={CheckCircleIcon} boxSize={4} color="#ffd700" data-id="element-682" /> Pago
                100% Seguro
              </Flex>
              <Flex align="center" gap={2} data-id="element-683">
                <Icon as={CheckCircleIcon} boxSize={4} color="#ffd700" data-id="element-684" /> Acceso
                Inmediato
              </Flex>
            </Flex>
          </Box>
        </VStack>
      </Container>
    </Box>;
}